import script from "./PublicMaquinasView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicMaquinasView.vue?vue&type=script&setup=true&lang=js"

import "./PublicMaquinasView.vue?vue&type=style&index=0&id=b6f8f092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6f8f092"]])

export default __exports__